import { render, staticRenderFns } from "./JModal.vue?vue&type=template&id=350e748e"
import script from "./JModal.vue?vue&type=script&lang=js"
export * from "./JModal.vue?vue&type=script&lang=js"
import style0 from "./JModal.vue?vue&type=style&index=0&id=350e748e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports